import type { ComponentProps } from "react";
import { Divider, FlexItem, H6, P } from "orcs-design-system";
import ExternalAppLinks from "src/components/Nav/ExternalAppLinks";
import {
  DEFAULT_CUSTOM_HELP_TITLE,
  DEFAULT_CUSTOM_HELP_DESCRIPTION,
} from "src/consts/helpMenuDefaults";

type CustomHelpMenuContentProps = {
  enabled: boolean;
  showCustomHelpContent: boolean;
  customHelpMenuTitle: string | undefined;
  customHelpMenuDescription: string | undefined;
  // filterLinksByLocationAndRole (untyped JS) declares its return as
  // `@returns {Array}`, so this is really `unknown[]` at the type level.
  links: unknown[];
};

const CustomHelpMenuContent = ({
  enabled,
  showCustomHelpContent,
  customHelpMenuTitle,
  customHelpMenuDescription,
  links,
}: CustomHelpMenuContentProps) => {
  const hasContent =
    enabled &&
    showCustomHelpContent &&
    (customHelpMenuTitle || customHelpMenuDescription || links.length > 0);

  if (!hasContent) {
    return null;
  }

  return (
    <>
      <FlexItem>
        <H6 fontWeight="bold" mb="s">
          {customHelpMenuTitle || DEFAULT_CUSTOM_HELP_TITLE}
        </H6>
        <P fontSize="1">
          {customHelpMenuDescription || DEFAULT_CUSTOM_HELP_DESCRIPTION}
        </P>
      </FlexItem>
      {/* TODO: ExternalAppLinks is an untyped React.memo component, so
          TS can't infer its props - see AppSwitcherContent for the
          same treatment. */}
      {links.length > 0 && (
        <ExternalAppLinks
          {...({ links } satisfies ComponentProps<typeof ExternalAppLinks>)}
        />
      )}
      <Divider light />
    </>
  );
};

export default CustomHelpMenuContent;
